// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

export enum PackageName {
  CredentialApp = 'utility-credential-app-v0',
  CommercialAgreement = 'utility-commercials-v0',
  Registry = 'utility-registry-v0',
  RegistryApp = 'utility-registry-app-v0',
  RegistryHolding = 'utility-registry-holding-v0',
  Splice = 'splice-amulet',
  CollateralApp = 'utility-collateral-app-v1',
  HostedApp = 'utility-hosted-app-v0',
}
